import './index.scss';
import React, { useEffect, useState } from 'react';
import { useAuth } from '~/providers/auth';
import { LAST_ACTION_TIMESTAMP } from '~/providers/inactivity';
const MINUTES_UNTIL_AUTO_LOGOUT = 15;
const SHOW_AT_TIME_REMAINING = 60;
let isShowingInterval;
const AutoLogoutModal = () => {
    const { signOut, isAuthenticated } = useAuth();
    const [isShowing, setIsShowing] = useState(false);
    const [timeRemaining, setTimeRemaining] = useState(0);
    useEffect(() => {
        isShowingInterval = window.setInterval(() => {
            if (!isAuthenticated) {
                setIsShowing(false);
                return;
            }
            const lastActionTimestamp = localStorage.getItem(LAST_ACTION_TIMESTAMP);
            if (lastActionTimestamp) {
                let lastAction = parseInt(JSON.parse(lastActionTimestamp));
                lastAction += (MINUTES_UNTIL_AUTO_LOGOUT * 60 * 1000);
                const now = Date.now();
                const timeLeft = Math.round((lastAction - now) / 1000);
                const isShowingNow = timeLeft < SHOW_AT_TIME_REMAINING && timeLeft >= 0;
                if (isShowingNow) {
                    setTimeRemaining(timeLeft);
                }
                setIsShowing(isShowingNow);
                if (timeLeft <= 0) {
                    signOut();
                    setIsShowing(false);
                }
            }
        }, 1000);
        return () => {
            if (isShowingInterval)
                clearInterval(isShowingInterval);
        };
    }, []);
    if (!isShowing)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { id: 'logout-modal-backdrop' },
        React.createElement("div", { id: 'auto-logout-modal', className: 'text-center' },
            React.createElement("h4", { id: 'auto-logout-head' }, "Are you still there?"),
            React.createElement("p", { id: 'auto-logout-body' },
                "Click anywhere to stay logged in or",
                React.createElement("br", null),
                "you will be logged out in ",
                timeRemaining,
                " seconds."),
            React.createElement("button", { className: 'remove-focus-highlight', id: 'log-out-now-button', onClick: signOut }, "Log out now"))));
};
export default AutoLogoutModal;
